import script from "./RequestArchives.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestArchives.vue?vue&type=script&setup=true&lang=js"

import "./RequestArchives.vue?vue&type=style&index=0&id=627e03b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627e03b0"]])

export default __exports__